import { useTranslation } from 'react-i18next';
import { Shield } from 'lucide-react';

export function SettingsReadOnlyBanner() {
  const { t } = useTranslation('settings');

  return (
    <div className="mb-6 flex items-start gap-3 rounded-2xl border border-border bg-muted/30 px-4 py-3 text-sm text-muted-foreground">
      <Shield size={18} className="mt-0.5 shrink-0 text-primary" aria-hidden />
      <p>{t('team.readOnlyNotice')}</p>
    </div>
  );
}
